import { render, staticRenderFns } from "./BookslotView.vue?vue&type=template&id=19bc3be5"
import script from "./BookslotView.vue?vue&type=script&lang=js"
export * from "./BookslotView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports